export const mockUser = {
  id: "u1",
  name: "Alex Rivera",
  email: "alex.rivera@email.com",
  avatar: "https://public.readdy.ai/ai/img_res/7f8aba405ec012e086b70145d8ae5930.jpg",
  bio: "Mindset enthusiast | Career coach in training | Passionate about helping others unlock their potential",
  niche: "Mindset & Career",
  role: "Coach",
  joinedDate: "January 2025",
  location: "New York, USA",
  followers: 1240,
  following: 387,
  programsEnrolled: 3,
  programsCreated: 2,
  totalEarnings: 4820,
  rating: 4.8,
};

export const mockStats = [
  { label: "Programs Enrolled", value: "3", icon: "ri-book-open-line", color: "text-emerald-600", bg: "bg-emerald-50" },
  { label: "Programs Created", value: "2", icon: "ri-award-line", color: "text-amber-600", bg: "bg-amber-50" },
  { label: "Total Earnings", value: "$4,820", icon: "ri-money-dollar-circle-line", color: "text-teal-600", bg: "bg-teal-50" },
  { label: "Community Rating", value: "4.8★", icon: "ri-star-line", color: "text-rose-600", bg: "bg-rose-50" },
];

export const mockMessages = [
  {
    id: "m1",
    sender: "Dr. Amara Osei",
    avatar: "https://readdy.ai/api/search-image?query=professional%20african%20woman%20coach%20smiling%20confident%20portrait%20studio%20lighting%20warm%20background&width=40&height=40&seq=av1&orientation=squarish",
    preview: "Hey Alex! I loved your post on career transitions. Would love to collaborate on a workshop...",
    timeAgo: "10 min ago",
    unread: true,
  },
  {
    id: "m2",
    sender: "Marcus Elliot",
    avatar: "https://readdy.ai/api/search-image?query=professional%20black%20man%20business%20coach%20confident%20portrait%20clean%20background&width=40&height=40&seq=av2&orientation=squarish",
    preview: "Thanks for enrolling in Career Accelerator! Let me know if you have any questions.",
    timeAgo: "2 hours ago",
    unread: true,
  },
  {
    id: "m3",
    sender: "Sophia Hartmann",
    avatar: "https://readdy.ai/api/search-image?query=professional%20european%20woman%20executive%20coach%20portrait%20clean%20studio%20background&width=40&height=40&seq=av3&orientation=squarish",
    preview: "Your feedback on the Corporate Leadership module was incredibly insightful. Thank you!",
    timeAgo: "Yesterday",
    unread: false,
  },
  {
    id: "m4",
    sender: "Kenji Nakamura",
    avatar: "https://readdy.ai/api/search-image?query=professional%20asian%20man%20life%20coach%20smiling%20portrait%20warm%20background&width=40&height=40&seq=av4&orientation=squarish",
    preview: "I saw your community post — brilliant framework! Would you be open to a collaboration?",
    timeAgo: "2 days ago",
    unread: false,
  },
];

export const mockActivity = [
  { id: "a1", type: "enrolled", text: "Enrolled in Career Accelerator Blueprint", timeAgo: "2 days ago", icon: "ri-book-open-line" },
  { id: "a2", type: "comment", text: "Commented on Dr. Osei's post about scarcity mindset", timeAgo: "3 days ago", icon: "ri-chat-3-line" },
  { id: "a3", type: "rating", text: "Rated Inner Confidence Unlocked — 5 stars", timeAgo: "5 days ago", icon: "ri-star-line" },
  { id: "a4", type: "post", text: "Published a new community post: Career Pivots at 30", timeAgo: "1 week ago", icon: "ri-edit-line" },
  { id: "a5", type: "earning", text: "Earned $320 from your Mindset Reset program", timeAgo: "1 week ago", icon: "ri-money-dollar-circle-line" },
];

export const mockEnrolledPrograms = [
  { id: "1", title: "Career Accelerator Blueprint", coach: "Marcus Elliot", progress: 65, cover: "https://readdy.ai/api/search-image?query=career%20growth%20upward%20arrow%20golden%20light%20professional%20success%20abstract%20geometric%20warm%20tones&width=200&height=120&seq=prog2&orientation=landscape" },
  { id: "5", title: "Inner Confidence Unlocked", coach: "Layla Hassan", progress: 30, cover: "https://readdy.ai/api/search-image?query=confidence%20empowerment%20woman%20silhouette%20sunrise%20golden%20light%20abstract%20artistic%20uplifting&width=200&height=120&seq=prog5&orientation=landscape" },
  { id: "4", title: "Life Blueprint: Design Your Future", coach: "Kenji Nakamura", progress: 90, cover: "https://readdy.ai/api/search-image?query=life%20journey%20path%20sunrise%20mountains%20horizon%20peaceful%20nature%20abstract%20artistic%20warm%20golden&width=200&height=120&seq=prog4&orientation=landscape" },
];
